export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.482183d009cb8c4fa013.worker.js");
}
